import SocketRx from '../../services/SocketRx'
import { ADD, UPDATE, DELETE } from '../mutation-types'
import Auth from '../../services/Auth'

const socketTypes = [
  'application',
  'applicationtype',
  'field',
  'flow',
  'group',
  'manufacturer',
  'service',
  'subject',
  'table',
  'user',
  'manatee_settings',
  'flow_restrictions',
  'estero_alert',
  'estero_alert_log'
]

const openSockets = {}
const reestablishConnectionIntervals = {}
const RECONNECT_INTERVAL = 5000 //ms
const RECONNECT_ATTEMPTS_LIMIT = 10

const mapData = data => {
  return { id: data.id, name: data.name, version: data.version, ...data.descriptive }
}

const openSocket = (type, store) => {
  let socketRx = SocketRx.open(type, '')

  socketRx.onCreate.subscribe(data => {
    store.commit(type + '/' + ADD, { data: mapData(data) })
  })

  socketRx.onUpdate.subscribe(
    data => {
      store.commit(type + '/' + UPDATE, { data: mapData(data) })
    },
    () => {}
  )

  socketRx.onDelete.subscribe(
    data => {
      store.commit(type + '/' + DELETE, { id: data.id })
    },
    () => {}
  )

  socketRx.onError.subscribe(error => {
    console.error(`SocketRx error ${type} : ${error}`)
    handleReestablishConnection(error)
  })

  socketRx.onClose.subscribe(closeEvent => {
    console.error(`SocketRx close ${type} : ${closeEvent}`)
    handleReestablishConnection(closeEvent)
  })

  openSockets[type] = socketRx

  // TODO: this logic really belongs in SocketRx behind a set of Subjects so event consumers don't need
  // TODO: to concern themselves with intermittent WS failure
  const handleReestablishConnection = evt => {
    openSockets[type] = null
    if (evt.code === 4001) {
      stopReestablishConnectionInterval()
      Auth.logOut()
    } else if (!reestablishConnectionIntervals[type]) {
      startReestablishConnectionInterval(type, store)
    }
  }

  const startReestablishConnectionInterval = (type, store) => {
    let reconnectionAttemptsCount = 0
    reestablishConnectionIntervals[type] = setInterval(() => {
      if (reconnectionAttemptsCount === RECONNECT_ATTEMPTS_LIMIT) {
        stopReestablishConnectionInterval()
        Auth.logOut()
      } else {
        reconnectionAttemptsCount++
        if (!openSockets[type] && Auth.isUserLoggedIn()) openSocket(type, store)
        else stopReestablishConnectionInterval()
      }
    }, RECONNECT_INTERVAL)
  }

  const stopReestablishConnectionInterval = (): void => {
    clearInterval(reestablishConnectionIntervals[type])
    reestablishConnectionIntervals[type] = false
  }
}

export default function createWebSocketPlugin() {
  return (store: any) => {
    store.subscribeAction(() => {
      socketTypes.forEach(type => {
        if (!openSockets[type] && Auth.isUserLoggedIn()) {
          openSocket(type, store)
        }
      })
    })
  }
}
